import { useState } from "react";
import { IFRSQuestionResponseOptionDTO } from "../../../../../api/Quiz/GetIFRSQuestionResponseOptions";

const useWordProcessor = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [content, setContent] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [currentResponseOption, setCurrentResponseOption] = useState<IFRSQuestionResponseOptionDTO | null>(null);

  return {
    isOpen,
    setIsOpen,
    content,
    setContent,
    isLoading,
    setIsLoading,
    currentResponseOption,
    setCurrentResponseOption,
  };
};

export default useWordProcessor;
